export default "__VITE_ASSET__cab89e3b__"